<template>
  <div class="grant-user-button" @click="grantUser" :class="cannotNominate ? 'disabled' : ''">
    <a class="grant-user-text">
      {{ $t('community.grantUserForOwnership.transferOwnership') }}
    </a>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'GrantUserForOwnership',
  props: {
    communityId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  methods: {
    grantUser() {
      if (!this.cannotNominate) {
        this.$store.dispatch('addOwnerRequest', { communityId: this.communityId, userId: this.userId })
      }
    }
  },
  computed: {
    ...mapState({
      ownerRequestForOwner: state => state.ownerRequest.ownerRequestForOwner
    }),
    getRequest() {
      return this.ownerRequestForOwner.filter(request => request.idCommunity === this.communityId)
    },
    cannotNominate() {
      return this.getRequest && this.getRequest.length > 0
    }
  }
}
</script>
<style scoped lang="scss">
.grant-user-button {
  padding: 4px 6px;
  width: 100%;
  height: 100%;

  .grant-user-text {
    height: 40px;
  }

  &:hover {
    background-color: $primary-color;
    color: white;
  }
}

.disabled {
  color: #d8d8d8;

  &:hover {
    cursor: default;
    background-color: white;
    color: #d8d8d8;
  }
}

</style>
